import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export type FeedbackCategory = 'bug' | 'idea' | 'agent' | 'other';

export interface ConversationTurn {
  role: 'user' | 'assistant';
  content: string;
}

export interface FeedbackRequest {
  category: FeedbackCategory;
  message: string;
  include_conversation: boolean;
  conversation?: ConversationTurn[];
  session_id?: string | null;
  agent_id?: string | null;
  agent_name?: string | null;
}

export interface FeedbackResult {
  saved: boolean;
  emailed: boolean;
  feedback_id?: string;
}

/**
 * Studio twin of the Hub's FeedbackService (wg-agents-ui). Submits one
 * feedback entry to POST <studio>/feedback — studio-api persists it to the
 * shared feedback table (source="agent-studio-ui") and emails the support DL.
 * Errors are NOT swallowed here — the caller distinguishes success (show the
 * "sent" state) from failure (keep the form open with an error).
 */
@Injectable({ providedIn: 'root' })
export class FeedbackService {
  private readonly http = inject(HttpClient);

  submitFeedback(req: FeedbackRequest): Observable<FeedbackResult> {
    const url = `${environment.BASE_URL}${environment.STUDIO_API.FEEDBACK}`;
    return this.http
      .post<{ success: boolean; body?: FeedbackResult }>(url, req)
      .pipe(
        map(res => ({
          saved: res?.body?.saved ?? !!res?.success,
          emailed: res?.body?.emailed ?? false,
          feedback_id: res?.body?.feedback_id,
        })),
      );
  }
}
